import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import AboutPage from "@/pages/AboutPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import DmcaPage from "@/pages/DmcaPage";
import FaqPage from "@/pages/FaqPage";
import HelpCenterPage from "@/pages/HelpCenterPage";
import TutorialsPage from "@/pages/TutorialsPage";
import AdvertisePage from "@/pages/AdvertisePage";
import AdminAnnouncementsPage from "@/pages/AdminAnnouncementsPage";
import AdminArabicWaitlistPage from "@/pages/AdminArabicWaitlistPage";
import DesiTVPage from "@/pages/packages/DesiTVPage";
import ArabicTVPage from "@/pages/packages/ArabicTVPage";

const ScrollToTopOrHash = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace("#", ""));
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTopOrHash />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/help" element={<HelpCenterPage />} />
          <Route path="/tutorials" element={<TutorialsPage />} />
          <Route path="/advertise" element={<AdvertisePage />} />
          <Route path="/packages/desi-tv"   element={<DesiTVPage />} />
          <Route path="/packages/arabic-tv" element={<ArabicTVPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/dmca" element={<DmcaPage />} />
          <Route path="/admin/announcements" element={<AdminAnnouncementsPage />} />
          <Route path="/admin/arabic-waitlist" element={<AdminArabicWaitlistPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
